import { render, staticRenderFns } from "./transactions.vue?vue&type=template&id=f61b09fe&scoped=true&"
import script from "./transactions.vue?vue&type=script&lang=js&"
export * from "./transactions.vue?vue&type=script&lang=js&"
import style0 from "./transactions.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./transactions.vue?vue&type=style&index=1&id=f61b09fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61b09fe",
  null
  
)

export default component.exports